import { render, staticRenderFns } from "./releaseListTable.vue?vue&type=template&id=1d51d82a&scoped=true"
import script from "./releaseListTable.vue?vue&type=script&lang=ts"
export * from "./releaseListTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d51d82a",
  null
  
)

export default component.exports